
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";

interface RelatedProduct {
  id: number;
  name: string;
  price: number;
  image: string;
  slug: string;
}

interface RelatedProductsProps {
  products: RelatedProduct[];
}

const RelatedProducts = ({ products }: RelatedProductsProps) => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-8">You Might Also Like</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {products.map((related) => (
          <Link key={related.id} to={related.slug} className="group">
            <div className="bg-white rounded-lg overflow-hidden shadow-md transition-all hover:shadow-lg">
              <div className="aspect-square overflow-hidden">
                <img
                  src={related.image}
                  alt={related.name}
                  className="w-full h-full object-cover transition-transform group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold mb-2 group-hover:text-primary transition-colors">
                  {related.name}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="font-medium">${related.price.toFixed(2)}</span>
                  <Button size="sm" variant="ghost">
                    <ShoppingBag className="h-4 w-4 mr-1" />
                    Add
                  </Button>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;
